import axios from "axios";

import AuthService from '../Auth/AuthService';

export default class EquipamentoService extends AuthService {


  /* LISTAR TODOS */
  listar() {
    return axios({
      method: 'get',
      url: this.api_url + 'equipamento',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      },
    }).then(res => res.data);
  }
  /* CADASTRAR */
  criar(equipamento) {
    return axios({
      method: 'post',
      url: this.api_url + 'equipamento',
      withCredentials: true,
      data: equipamento,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }
  /* REMOVER */
  remover(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'equipamento/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
  /* ATUALIZAR */
  atualizar(id, equipamento) {
    return axios({
      method: 'put',
      url: this.api_url + 'equipamento/' + id,
      withCredentials: true,
      data: equipamento,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }
}
